import React from 'react';

import { Tag } from 'tags/models/tagsApi.types';
import { TagsCell } from 'src/common/components/ConfigurableTable/Components/Cells/TagsCell';

type RSimTagsCellProps = {
  row: {
    tags?: { items: Tag[]; hasMore: boolean };

    euicc: string;
  };
};

export const RSimTagsCell: React.FC<RSimTagsCellProps> = React.memo(
  ({ row }: RSimTagsCellProps) => {
    return <TagsCell tags={row.tags?.items} hasMore={row.tags?.hasMore || false} id={row.euicc} />;
  },
);
